import type { BrowserObservationEvent } from "@workerstation/shared/browser-observability-model";
export function eventDetails(event: BrowserObservationEvent) {
  return {
    id: event.id,
    sequence: event.sequence,
    timestamp: new Date(event.timestamp).toISOString(),
    workspaceId: event.workspaceId,
    stationId: event.stationId,
    workerName: event.workerName,
    bindingName: event.bindingName,
    namespace: event.namespace,
    sessionId: event.sessionId,
    protocolSessionId: event.protocolSessionId,
    direction: event.direction,
    kind: event.kind,
    category: event.category,
    level: event.level,
    method: event.method,
    summary: event.summary,
    url: event.url,
    requestId: event.requestId,
    frameId: event.frameId,
    changeId: event.changeId,
    taskId: event.taskId,
    runId: event.runId,
    parentRunId: event.parentRunId,
    attemptId: event.attemptId,
    worktreeId: event.worktreeId,
    treeId: event.treeId,
    inputTreeId: event.inputTreeId,
    outputTreeId: event.outputTreeId,
    candidateId: event.candidateId,
    checkId: event.checkId,
    reviewId: event.reviewId,
    runtimeNamespaceId: event.namespaceId,
    fence: event.fence,
    cacheResult: event.cacheResult,
    eventSequence: event.eventSequence,
    targetRef: event.targetRef,
    phase: event.phase,
    sizeBytes: event.sizeBytes,
    payload: event.payload
  };
}
